<template>
  <div class="wechatPayContent" v-if="isLogined&&!isError">
    <div class="wechatPayHead">
      <div class="payHead1">请及时付款，以便订单尽快处理！</div>
      <div class="payHead2">
        <div class="countdown">请在<span>{{timecount}}</span>内付款，否则交易会被取消</div>
        <div class="orderAmount">￥{{Number(orderTotal).toFixed(2)}}</div>      
        <div class="payLabel">实付：</div>          
      </div>
    </div>
    <div class="wechatPayContent">
      <div class="payContentLeft">
        <div class="pic"><div ref="qrcodeContainer"></div></div>        
        <div class="timeout" v-if="timeout"  ><div>二维码已过期</div></div>
        <div class="prompt" v-else><div>微信扫码支付</div></div>
        <div class="refresh" v-if="timeout"  @click="refresh"><div>刷新</div></div>
      </div>
      <div class="payContentRight">
        <img src="http://img.static.knnnj.com/Default/a83350bf-bffe-478a-931d-ee5ec03b633f.png">
      </div>
    </div>    
  </div>
  <div class="wechatPayContent1" v-else >
    <div v-if="!isLogined" @click="toLogin()">亲,请先登陆</div>
    <div class="errorMsg" v-else>{{errorMsg}}</div>
  </div>
</template>
<style>
@import '../../styles/wechat.css';
</style>
<script>
  import api from '@/api'
  import {getPaymentQrCode, getPayStatus} from '@/api/order'
  import QRCode from 'qrcodejs2' 
  import { getStore, setStore } from '@/utils/storage'
  import { mapState} from 'vuex'
  export default {
    data () {
      return {
        show: true,
        num: '',
        orderTotal: '',
        nickName: '',
        money: '',
        info: '',
        email: '',
        nativeCodeUrl: '',
        picName: '',
        timeout: false,
        timecount: '',
        qrcode:'',
        outTradeNo:'',
        method:'weixin',
        time:'',
        isError:false,
        errorMsg:''
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: {
      toMoney (num) {
        num = parseFloat(num)
        num = num.toFixed(2)
        num = num.toLocaleString()
        return num
      },
      messageFail (m) {
        this.$message.error({ message: m })
      },   
      countTime () {
        let me = this
        let time = getStore('setTime')
        if (time <= 0) {
          this.timeout = true
          this.timecount = ''
          this.count = 10000
          return
        } else {
          time--
          this.showTime(time)
          setStore('setTime', time)
        }
        setTimeout(function () {
          me.countTime()
        }, 1000)
      },
      showTime (v) {
        let m = 0
        let s = 0
        if (v === null || v === '') {
          return ''
        }
        if (v >= 60) {
          m = Math.floor(v / 60)
          s = v % 60
        } else {
          s = v
        }
        if (m >= 0 && m <= 9) {
          m = '0' + m
        }
        if (s >= 0 && s <= 9) {
          s = '0' + s
        }
        this.timecount = m + '分' + s + '秒'
        
      },
      paySuc () {
        this.$router.push({path: '/order/paysuccess', query: {price: this.orderTotal}})
      },
      showQRCode(url){  
          this.qrcode = new QRCode(this.$refs.qrcodeContainer, {
            text: url,  
            width: 168,  
            height: 160,  
            colorDark: '#000000',  
            colorLight: '#ffffff',  
            correctLevel: QRCode.CorrectLevel.H  
          })
      },
      refresh(){
        this.qrcode.clear();
        var param ={
          orderCodes : this.orderId,
          outTradeNo : this.outTradeNo,
          method : this.method
        };
        getPaymentQrCode(param).then(res => {        
          if(res.data.success)
          {
            this.qrcode.makeCode(res.data.result.nativeCodeUrl)
            this.count = 90
            this.timeout = false
            setStore('setTime', 90)
            this.countTime()
          }else
          {
            this.messageFail(res.data.error.message)
          }
        })
      },
      getPayStatus(){
        let tempOutTradeNo = this.outTradeNo
        if(!this.timeout){
          getPayStatus({ outTradeNo : tempOutTradeNo }).then(res => {
            if(res.data.result){
              window.clearInterval(this.time)
              this.paySuc()
            }
          })
        }
        
      },
      getPaymentQrCode(){
        let orderCodes = this.orderId
        let outTradeNo = this.outTradeNo
        let method = this.method
        let that = this
        var param ={
          orderCodes : this.orderId,
          outTradeNo : this.outTradeNo,
          method : this.method
        };
        getPaymentQrCode(param).then(res => {        
           if(res.data.success){
              this.orderTotal = this.toMoney(res.data.result.amount)
              this.outTradeNo = res.data.result.outTradeNo
              setStore('outTradeNo',res.data.result.outTradeNo)
              this.showQRCode(res.data.result.nativeCodeUrl)
              this.countTime()
              this.time = window.setInterval(function () {
                  that.getPayStatus()
                }, 1000)
           }else{
            this.isError = true;
            this.errorMsg = res.data.error.message;
            
           }
        })
      },
      
    },
    mounted () {
      if(this.isLogined)
      {
        setStore('setTime', 90)
        this.orderId = this.$route.query.orderId
        this.getPaymentQrCode()
      }
      else
      {
        this.$router.push({ name: 'userLogin' })
      }
    },
    components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wechat.vue?69535578